/**
 * A rolagem da conversa — a conta, sem uma linha de desenho.
 *
 * É a parte da trilha que mais quebrava e a que menos dá para ver num teste de
 * tela: descer ao chegar mensagem nova, NÃO descer se quem lê está no meio do
 * histórico, e devolver a rolagem à mesma linha depois de o pedaço anterior
 * entrar por cima. As três são aritmética de `scrollTop`, então moram aqui e a
 * `Trilha.jsx` fica com a pintura.
 */

/** Está lendo o fim? 160px de folga: a última bolha ainda está visível. */
export const naBase = (el, folga = 160) => !el || el.scrollHeight - el.scrollTop - el.clientHeight <= folga;

/**
 * O que mudou entre duas listas de mensagens.
 *
 * Sem isto a trilha tinha um `useEffect` em `mensagens.length` que descia para o
 * fim a cada mudança — inclusive quando o que mudou foi o HISTÓRICO entrando por
 * cima, e quem estava lendo a primeira semana do atendimento era jogado para
 * hoje. São três movimentos diferentes com três respostas diferentes:
 *
 *   `caso`     → conversa outra: pousa no fim (ou no divisor de não lidas)
 *   `fim`      → chegou/saiu mensagem: desce SE estava no fim, senão conta
 *   `comeco`   → o pedaço anterior subiu: devolve a rolagem à mesma linha
 *   `nenhum`   → releitura sem novidade (reação, tique, entrega): não mexe
 */
export function oQueMudou(antes, agora) {
  if (antes.casoId !== agora.casoId) return "caso";
  if (!antes.quantas && agora.quantas) return "caso";
  if (antes.primeiro !== agora.primeiro && agora.quantas > antes.quantas) return "comeco";
  if (antes.ultimo !== agora.ultimo) return "fim";
  /* Mesma primeira e mesma última, mas cresceu: mensagem entrou NO MEIO — é a
     sincronização do histórico do celular preenchendo buraco. Não move a
     rolagem, senão a tela pula sozinha enquanto o aparelho sincroniza. */
  return "nenhum";
}

/** O retrato de uma lista de mensagens, para comparar com o próximo. */
export const retrato = (mensagens, casoId) => ({
  casoId,
  quantas: mensagens.length,
  primeiro: mensagens[0]?.id ?? null,
  ultimo: mensagens[mensagens.length - 1]?.id ?? null,
});
